/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import template from './related-data-traffic.component.html';
import {CHART_IMPORTS} from './chart-imports';
import {LineChartComponent} from './line-chart.component';

@Component({
  imports: [...CHART_IMPORTS, LineChartComponent],
  selector: 'adn-related-data-traffic',
  template
})
export class RelatedDataTrafficComponent {
  @Input() allStats: any;
  @Input() countType: any;
  @Input() relatedChartData: any;
  @Input() changeHook: any;
  @Input() chartType: string;
  @Input() osEmpty = false;
  @Input() mobileBrandEmpty = false;
  @Input() appEmpty = false;
  @Input() isSpecialUser = false;
  @Input() isPending = false;
}
